import { TableSchema } from '../metadata-schema';
import { dim_per_periode } from './dim_per_periode';
import { dim_br_brin } from './dim_br_brin';
import { dim_ilt_opleidingscode } from './dim_ilt_opleidingscode';
import { instelling } from './instelling';
import { fac_lb_loopbaan } from './fac_lb_loopbaan';
import { dim_ll_leerling } from './dim_ll_leerling';
import { dim_mw_medewerker } from './dim_mw_medewerker';
import { dim_vs_vestiging } from './dim_vs_vestiging';
import { fac_af_afspraak } from './fac_af_afspraak';
import { dim_lg_lesgroep } from './dim_lg_lesgroep';
import { dim_vk_vak } from './dim_vk_vak';
import { Interventielaag } from '../enums/Interventielaag';

export const fac_aw_aanwezigheid: TableSchema = {
	"$schema": "https://json-schema.org/draft/2020-12/schema",
	"title": "fac_aw_aanwezigheid",
	"description": "Definitie voor fact tabel fac_aw_aanwezigheid uit de CumLaude DWH",
	"type": "object",
	"implements": [
		"nl.topicus.cumlaude.metadata.table.FacTable",
		"nl.topicus.cumlaude.metadata.table.Leerlingspecifiek",
		"nl.topicus.cumlaude.metadata.table.Vestigingspecifiek",
		"nl.topicus.cumlaude.metadata.table.Vakspecifiek"
	],
	"agg-tables": [
		"fac_aw_aanwezigheid_agg_maand",
		"fac_aw_aanwezigheid_agg_dag_reden",
		"fac_aw_aanwezigheid_agg_maand_reden_vak"
	],
	"properties": {
		"aw_abbs_vak": {
			"type": "array",
			"items": {
				"type": "string"
			},
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"aw_d_datum": {
			"description": "Definitie voor dimension tabel dim_per_periode uit de CumLaude DWH",
			"type": "object",
			"schema": dim_per_periode
		},
		"aw_fk_br_inst": {
			"include": [],
			"description": "Definitie voor dimension tabel dim_br_brin uit de CumLaude DWH",
			"type": "object",
			"schema": dim_br_brin
		},
		"aw_fk_br_vest": {
			"description": "Definitie voor dimension tabel dim_br_brin uit de CumLaude DWH",
			"type": "object",
			"schema": dim_br_brin
		},
		"aw_fk_ilt": {
			"description": "Definitie voor dimension tabel dim_ilt_opleidingscode uit de CumLaude DWH",
			"type": "object",
			"schema": dim_ilt_opleidingscode
		},
		"aw_fk_ilt_volgend_sj": {
			"labelSuffix": "volgend schooljaar",
			"include": [
				"ilt_nm_niveau"
			],
			"description": "Definitie voor dimension tabel dim_ilt_opleidingscode uit de CumLaude DWH",
			"type": "object",
			"schema": dim_ilt_opleidingscode
		},
		"aw_fk_ilt_vorig_sj": {
			"labelSuffix": "vorig schooljaar",
			"include": [
				"ilt_nm_niveau"
			],
			"description": "Definitie voor dimension tabel dim_ilt_opleidingscode uit de CumLaude DWH",
			"type": "object",
			"schema": dim_ilt_opleidingscode
		},
		"aw_fk_inst": {
			"description": "Definitie voor sys tabel instelling uit de CumLaude sys",
			"type": "object",
			"schema": instelling
		},
		"aw_fk_lb": {
			"exclude": [
				"lb_co_brin_svh",
				"lb_co_brin_vestiging",
				"lb_nm_klas",
				"lb_nm_lichting",
				"lb_nm_onderwijssoort",
				"lb_nm_vestiging",
				"lb_nr_leerjaar"
			],
			"description": "Definitie voor fact tabel fac_lb_loopbaan uit de CumLaude DWH",
			"type": "object",
			"schema": fac_lb_loopbaan
		},
		"aw_fk_lb_volgend_sj": {
			"labelSuffix": "volgend schooljaar",
			"include": [
				"lb_abb_leerfase",
				"lb_co_brin",
				"lb_co_brin_vestiging",
				"lb_nm_klas",
				"lb_nm_leerfase",
				"lb_nm_opleiding",
				"lb_nm_vestiging",
				"lb_nr_leerjaar"
			],
			"description": "Definitie voor fact tabel fac_lb_loopbaan uit de CumLaude DWH",
			"type": "object",
			"schema": fac_lb_loopbaan
		},
		"aw_fk_lb_vorig_sj": {
			"labelSuffix": "vorig schooljaar",
			"include": [
				"lb_abb_leerfase",
				"lb_co_brin",
				"lb_co_brin_vestiging",
				"lb_nm_klas",
				"lb_nm_leerfase",
				"lb_nm_opleiding",
				"lb_nm_vestiging",
				"lb_nr_leerjaar"
			],
			"description": "Definitie voor fact tabel fac_lb_loopbaan uit de CumLaude DWH",
			"type": "object",
			"schema": fac_lb_loopbaan
		},
		"aw_fk_ll": {
			"exclude": [
				"ll_is_cohortstatus_tot_volledig",
				"ll_nm_basisschooladvies",
				"ll_nm_basisschooladvies_uni",
				"ll_nm_basisschooladvies_uni_herzien",
				"ll_nm_onderwijssoort_svb",
				"ll_nm_schoolsoort_svb",
				"ll_nm_schoolsoort_svh",
				"ll_nm_svb",
				"ll_nm_svh",
				"ll_nr_citototaalscore"
			],
			"description": "Definitie voor dimension tabel dim_ll_leerling uit de CumLaude DWH",
			"type": "object",
			"schema": dim_ll_leerling
		},
		"aw_fk_mw_mentor1": {
			"labelOverride": {
				"mw_abb_medewerker": "Eerste mentor (afkorting)",
				"mw_nm_medewerker": "Eerste mentor"
			},
			"categoryOverride": {
				"mw_abb_medewerker": "Opleiding",
				"mw_nm_medewerker": "Opleiding"
			},
			"descriptionOverride": {
				"mw_abb_medewerker": "De afkorting van de eerste mentor.",
				"mw_nm_medewerker": "De achternaam, voornaam/-letters, eventueel voorvoegsel en afkorting van de eerste mentor."
			},
			"description": "Definitie voor dimension tabel dim_mw_medewerker uit de CumLaude DWH",
			"type": "object",
			"schema": dim_mw_medewerker
		},
		"aw_fk_mw_mentor2": {
			"labelOverride": {
				"mw_abb_medewerker": "Tweede mentor (afkorting)",
				"mw_nm_medewerker": "Tweede mentor"
			},
			"categoryOverride": {
				"mw_abb_medewerker": "Opleiding",
				"mw_nm_medewerker": "Opleiding"
			},
			"descriptionOverride": {
				"mw_abb_medewerker": "De afkorting van de tweede mentor.",
				"mw_nm_medewerker": "De achternaam, voornaam/-letters, eventueel voorvoegsel en afkorting van de tweede mentor."
			},
			"description": "Definitie voor dimension tabel dim_mw_medewerker uit de CumLaude DWH",
			"type": "object",
			"schema": dim_mw_medewerker
		},
		"aw_fk_mw_mentor_indiv": {
			"labelOverride": {
				"mw_abb_medewerker": "Individuele mentor (afkorting)",
				"mw_nm_medewerker": "Individuele mentor"
			},
			"categoryOverride": {
				"mw_abb_medewerker": "Opleiding",
				"mw_nm_medewerker": "Opleiding"
			},
			"descriptionOverride": {
				"mw_abb_medewerker": "De afkorting van de individuele mentor.",
				"mw_nm_medewerker": "De achternaam, voornaam/-letters, eventueel voorvoegsel en afkorting van de individuele mentor."
			},
			"description": "Definitie voor dimension tabel dim_mw_medewerker uit de CumLaude DWH",
			"type": "object",
			"schema": dim_mw_medewerker
		},
		"aw_fk_vs": {
			"description": "Definitie voor dimension tabel dim_vs_vestiging uit de CumLaude DWH",
			"type": "object",
			"schema": dim_vs_vestiging
		},
		"aw_fk_vs_bekostiging": {
			"include": [],
			"description": "Definitie voor dimension tabel dim_vs_vestiging uit de CumLaude DWH",
			"type": "object",
			"schema": dim_vs_vestiging
		},
		"aw_fks_af": {
			"type": "array",
			"items": {
				"include": [
					"af_is_presentieregistratie_verplicht",
					"af_is_presentieregistratie_verwerkt",
					"af_nm_afspraaktype"
				],
				"description": "Definitie voor fact tabel fac_af_afspraak uit de CumLaude DWH",
				"type": "object",
				"schema": fac_af_afspraak
			}
		},
		"aw_fks_lg": {
			"type": "array",
			"items": {
				"exclude": [
					"lg_nm_docenten"
				],
				"description": "Definitie voor dimension tabel dim_lg_lesgroep uit de CumLaude DWH",
				"type": "object",
				"schema": dim_lg_lesgroep
			}
		},
		"aw_fks_mw": {
			"type": "array",
			"items": {
				"description": "Definitie voor dimension tabel dim_mw_medewerker uit de CumLaude DWH",
				"type": "object",
				"schema": dim_mw_medewerker
			}
		},
		"aw_fks_vk": {
			"type": "array",
			"items": {
				"description": "Definitie voor dimension tabel dim_vk_vak uit de CumLaude DWH",
				"type": "object",
				"schema": dim_vk_vak
			}
		},
		"aw_fun_abb_medewerker_afspraak": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"label": "Docent (afkorting)",
			"category": "Vak",
			"example": "JNS, VDK",
			"description": "De afkorting van de docent van deze les. Dit hoort bij de les, niet bij de leerling.",
			"blocklist": {
				"bestuur": true
			}
		},
		"aw_fun_abb_vak": {
			"type": "string",
			"label": "Vak (afk)",
			"category": "Vak",
			"example": "entl, wisA, ...",
			"description": "De afkorting van het vak van deze les."
		},
		"aw_fun_abb_vak_afspraak": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"label": "Vak (afk)",
			"category": "Vak",
			"example": "entl, wisA, ...",
			"description": "De afkorting van het vak van deze les. Dit hoort bij de les, niet bij de leerling."
		},
		"aw_fun_is_plaatsing_peildatum_1april": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-aprilplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of de plaatsing die actief was op de datum van deze les ook actief was op 1 april van dit schooljaar\nIndien Nee, kan het zijn dat de leerling op 1 april wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"aw_fun_is_plaatsing_peildatum_1aug": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-augustusplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of de plaatsing die actief was op de datum van deze les ook actief was op 1 augustus van dit schooljaar\nIndien Nee, kan het zijn dat de leerling op 1 augustus wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"aw_fun_is_plaatsing_peildatum_1dec": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-decemberplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of de plaatsing die actief was op de datum van deze les ook actief was op 1 december van dit schooljaar\nIndien Nee, kan het zijn dat de leerling op 1 december wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"aw_fun_is_plaatsing_peildatum_1feb": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-februariplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of de plaatsing die actief was op de datum van deze les ook actief was op 1 februari van dit schooljaar\nIndien Nee, kan het zijn dat de leerling op 1 februari wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"aw_fun_is_plaatsing_peildatum_1jan": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-januariplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of de plaatsing die actief was op de datum van deze les ook actief was op 1 januari van dit schooljaar\nIndien Nee, kan het zijn dat de leerling op 1 januari wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"aw_fun_is_plaatsing_peildatum_1juli": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-juliplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of de plaatsing die actief was op de datum van deze les ook actief was op 1 juli van dit schooljaar\nIndien Nee, kan het zijn dat de leerling op 1 juli wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"aw_fun_is_plaatsing_peildatum_1juni": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-juniplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of de plaatsing die actief was op de datum van deze les ook actief was op 1 juni van dit schooljaar\nIndien Nee, kan het zijn dat de leerling op 1 juni wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"aw_fun_is_plaatsing_peildatum_1mei": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-meiplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of de plaatsing die actief was op de datum van deze les ook actief was op 1 mei van dit schooljaar\nIndien Nee, kan het zijn dat de leerling op 1 mei wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"aw_fun_is_plaatsing_peildatum_1mrt": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-maartplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of de plaatsing die actief was op de datum van deze les ook actief was op 1 maart van dit schooljaar\nIndien Nee, kan het zijn dat de leerling op 1 maart wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"aw_fun_is_plaatsing_peildatum_1nov": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-novemberplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of de plaatsing die actief was op de datum van deze les ook actief was op 1 november van dit schooljaar\nIndien Nee, kan het zijn dat de leerling op 1 november wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"aw_fun_is_plaatsing_peildatum_1okt": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-oktoberplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of de plaatsing die actief was op de datum van deze les ook actief was op 1 oktober van dit schooljaar\nIndien Nee, kan het zijn dat de leerling op 1 oktober wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"aw_fun_is_plaatsing_peildatum_1sep": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-septemberplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of de plaatsing die actief was op de datum van deze les ook actief was op 1 september van dit schooljaar\nIndien Nee, kan het zijn dat de leerling op 1 september wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"aw_fun_is_presentieregistratie_verplicht_afspraak": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false,
			"label": "Presentieregistratie verplicht",
			"category": "Afwezigheid",
			"example": "Ja, Nee",
			"description": "Geeft aan of in het afspraaktype van deze les is aangegeven dat er een presentieregistratie moet plaatsvinden. Dit hoort bij de les, niet bij de leerling.",
			"blocklist": {
				"magister": true
			}
		},
		"aw_fun_nm_abs_reden": {
			"type": "string",
			"label": "Reden",
			"category": "Afwezigheid",
			"example": "Ziek, Spijbelen, ...",
			"description": "De absentiereden die is geregistreerd voor dit lesuur of deze les.\nLeeg indien de leerling present was.\nIn het geval van absentiemeldingen van het type \"te laat\" of \"verwijderd\" wordt geen afwezigheid opgeslagen, maar een lesregistratie."
		},
		"aw_fun_nm_absentiecategorie": {
			"type": "string",
			"label": "Absentiecategorie",
			"category": "Afwezigheid",
			"example": "Te laat, Absent, ...",
			"description-somtoday": "De constateringsoort van de geregistreerde absentiereden.",
			"description-magister": "Het type registratie (verantwoordingstype) van de geregistreerde absentiereden."
		},
		"aw_fun_nm_afspraaktype": {
			"type": "string",
			"label": "Afspraaktype",
			"category": "Afwezigheid",
			"example": "Les, Kwt, Persoonlijk, ...",
			"description-somtoday": "Het type van de afspraak waarvoor deze aanwezigheidsregistratie geldt.",
			"description-magister": "Het type van de afspraak waarvoor deze aanwezigheidsregistratie geldt.\nDe mogelijke waarden zijn: Onbekend, Persoonlijk, Algemeen, Schoolbreed, Stage, Kwt, Les of Planning."
		},
		"aw_fun_nm_instroommoment": {
			"type": "string",
			"label": "Instroommoment",
			"filter": false,
			"category": "Doorstroom",
			"example": "T/m 1 oktober, Na 1 oktober, Na 1 november, ...",
			"description": "Het moment binnen het schooljaar waarin de leerling is ingestroomd vanuit een andere school of vestiging.\nIndien de leerling is ingestroomd op of voor 1 oktober van dit schooljaar, is deze waarde 'T/m 1 oktober', anders 'Na' de voorgaande eerste van de maand (oktober t/m juli).\nLeeg als deze leerling dit schooljaar niet is ingestroomd vanuit een andere school of vestiging."
		},
		"aw_fun_nm_interventielaag": {
			"label": "Interventielaag",
			"category": "Afwezigheid",
			"exportable": false,
			"filter": false,
			"grouping": false,
			"example": "Goede aanwezigheid, Beginnend verzuim, Aanhoudend verzuim",
			"description": "Classificatie van een leerling/klas/vak in een van de drie interventielagen van het piramideraamwerk (MD-MTSS-model) op basis van aanwezigheidspercentage.\nHierin staat \"Goede aanwezigheid\" voor ≥ 95% aanwezig, \"Beginnend verzuim\" voor 90% - 95% aanwezig, en \"Aanhoudend verzuim\" voor ≤ 90% aanwezig.\nDe classificatie hangt af van andere filters om bijv. de periode vast te stellen.",
			"type": "string",
			"schema": Interventielaag
		},
		"aw_fun_nm_lesgroep_afspraak": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"label": "Lesgroep",
			"category": "Vak",
			"example": "1een, h5cnetl, ...",
			"description": "De lesgroep van deze les. Dit hoort bij de les, niet bij de leerling."
		},
		"aw_fun_nm_medewerker_afspraak": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"label": "Docent",
			"category": "Vak",
			"example": "Jansen, L. (JNS); Dijk, Evert van (VDK)",
			"description": "De docent van deze les. Dit hoort bij de les, niet bij de leerling.",
			"blocklist": {
				"bestuur": true
			}
		},
		"aw_fun_nm_nationaliteit": {
			"type": "string",
			"label": "Nationaliteit",
			"category": "Leerling",
			"grouping": false,
			"exportable": false,
			"example": "Nederlandse, Turkse, ...",
			"description-magister": "De eerste of tweede nationaliteit van deze leerling.",
			"description-somtoday": "De eerste of tweede nationaliteit van deze leerling.\nIndien in Somtoday de nationaliteit volgens het BRP is ingevuld, wordt dit \nveld gebruikt, tenzij het vinkje \"wijkt bewust af\" is ingeschakeld."
		},
		"aw_fun_nm_vak": {
			"type": "string",
			"label": "Vak",
			"category": "Vak",
			"example": "Engels, wiskunde A, ...",
			"description": "Het vak van deze les."
		},
		"aw_fun_nm_vak_afspraak": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"label": "Vak",
			"category": "Vak",
			"example": "Engels, wiskunde A, ...",
			"description": "Het vak van deze les. Dit hoort bij de les en niet bij de leerling: had de leerling meerdere\nlessen op hetzelfde lesuur, dan houdt elke les hier zijn eigen vak."
		},
		"aw_fun_nr_maanden_instroom_na_1okt": {
			"type": "integer",
			"minimum": 0,
			"maximum": 10,
			"label": "Instroommoment",
			"grouping": false,
			"exportable": false,
			"category": "Doorstroom",
			"example": "0 - 10",
			"description": "Het aantal maanden (afgerond naar boven) tussen 1 oktober van dit schooljaar en het moment van instroom, mits deze leerling dit schooljaar is ingestroomd vanuit een andere school of vestiging.\nIndien de leerling is ingestroomd op of voor 1 oktober van dit schooljaar, is deze waarde 0.\nLeeg als deze leerling dit schooljaar niet is ingestroomd vanuit een andere school of vestiging."
		},
		"aw_fun_nr_plaatsing_advies_score": {
			"type": "number",
			"label": "Pl./adviesverschil (score)",
			"category": "Plaatsing",
			"example": "-1; 0; 0,5; 1",
			"description": "De score die de inspectie toekent voor deze leerling op basis van het verschil tussen het niveau van deze plaatsing met het basisschooladvies:\n- -1 als het niveau van deze plaatsing lager is dan het basisschooladvies\n- 0 als het niveau van deze plaatsing gelijk is aan het basisschooladvies\n- 0,5 als het niveau van deze plaatsing HAVO / VWO is, en het basisschooladvies HAVO\n- 1 als het niveau van deze plaatsing hoger is dan het basisschooladvies\n\nBij dubbele adviezen (bijvoorbeeld VMBO b / VMBO k) wordt vergeleken met het laagste; bij driedubbele adviezen (VMBO k t/m HAVO) met het middelste (VMBO (g)t).\nDe score voor de eerste plaatsing in leerjaar 3 wordt gebruikt in de berekening van de indicator Onderwijspositie in het onderwijsresultatenmodel."
		},
		"aw_fun_nr_plaatsing_advies_verschil": {
			"type": "number",
			"label": "Pl./adviesverschil (niveaus)",
			"category": "Plaatsing",
			"example": "0; -1,5; 2; -0,5; ...",
			"description": "Het aantal niveaus verschil tussen het niveau van deze plaatsing en het basisschooladvies. Bij en positief aantal zit de leerling boven niveau; bij een negatief aantal onder niveau.\nHalve niveaus ontstaan bij dubbele adviezen en/of gecombineerde niveaus, zoals VMBO b / VMBO k en HAVO / VWO."
		},
		"aw_fun_nr_plaatsing_lj3_advies_score": {
			"type": "number",
			"label": "Pl./adviesverschil lj3 (score)",
			"category": "Plaatsing",
			"example": "-1; 0; 0,5; 1",
			"description": "De score die de inspectie toekent voor deze leerling op basis van het verschil tussen het niveau van de eerste plaatsing in leerjaar 3 met het basisschooladvies:\n- -1 als het niveau van leerjaar 3 lager is dan het basisschooladvies\n- 0 als het niveau van leerjaar 3 gelijk is aan het basisschooladvies\n- 0,5 als het niveau van leerjaar 3 HAVO / VWO is, en het basisschooladvies HAVO\n- 1 als het niveau van leerjaar 3 hoger is dan het basisschooladvies\n\nBij dubbele adviezen (bijvoorbeeld VMBO b / VMBO k) wordt vergeleken met het laagste; bij driedubbele adviezen (VMBO k t/m HAVO) met het middelste (VMBO (g)t).\nDeze score wordt gebruikt in de berekening van de indicator Onderwijspositie in het onderwijsresultatenmodel."
		},
		"aw_fun_nr_plaatsing_lj3_advies_verschil": {
			"type": "number",
			"label": "Pl./adviesverschil lj3 (niveaus)",
			"category": "Plaatsing",
			"example": "0; -1,5; 2; -0,5; ...",
			"description": "Het aantal niveaus verschil tussen het niveau van de eerste plaatsing in leerjaar 3 van deze leerling en het basisschooladvies. Bij en positief aantal zit de leerling boven niveau; bij een negatief aantal onder niveau.\nHalve niveaus ontstaan bij dubbele adviezen en/of gecombineerde niveaus, zoals VMBO b / VMBO k en HAVO / VWO."
		},
		"aw_id_vestiging": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"aw_is_aanwezig_geconstateerd": {
			"type": "number",
			"minimum": 0,
			"maximum": 1,
			"label": "Aanwezig geconstateerd",
			"category": "Afwezigheid",
			"example": "Ja, Nee",
			"description-somtoday": "Geeft aan of de leerling in dit lesuur door de docent aanwezig is geregistreerd. Er is dan een constatering van type Aanwezig.",
			"description-magister": "Geeft aan of de leerling in dit lesuur door de docent aanwezig is geregistreerd. Er is dan een verantwoording van type Present."
		},
		"aw_is_abs_geoorloofd": {
			"type": "number",
			"minimum": 0,
			"maximum": 1,
			"label": "Geoorloofd",
			"category": "Afwezigheid",
			"example": "Ja, Nee",
			"description": "Geeft aan of de absentiereden die is geregistreerd voor dit lesuur of deze les van het type \"Geoorloofd\" is.\nGeoorloofde absentieredenen zijn bijvoorbeeld Ziekte en Doktersbezoek."
		},
		"aw_is_absent": {
			"type": "number",
			"minimum": 0,
			"maximum": 1,
			"label": "Afwezig",
			"category": "Afwezigheid",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description": "Geeft aan of er een absentiemelding (met reden) voor dit lesuur is."
		},
		"aw_is_presentieregistratie_verplicht": {
			"type": "number",
			"minimum": 0,
			"maximum": 1,
			"label": "Presentieregistratie verplicht",
			"category": "Afwezigheid",
			"example": "Ja, Nee",
			"filter": true,
			"grouping": true,
			"exportable": true,
			"description": "Geeft aan of in het afspraaktype van deze les is aangegeven dat er een presentieregistratie moet plaatsvinden.",
			"blocklist": {
				"magister": true
			}
		},
		"aw_is_presentieregistratie_verwerkt": {
			"type": "number",
			"minimum": 0,
			"maximum": 1,
			"label": "Afgesloten les",
			"category": "Afwezigheid",
			"example": "Ja, Nee",
			"filter": true,
			"grouping": true,
			"exportable": true,
			"description": "Geeft aan of de presentie voor deze leerling voor deze les is geregistreerd. Normaliter is dit het geval als de les is afgesloten door de docent."
		},
		"aw_nm_klas": {
			"type": "string",
			"label": "Klas",
			"category": "Opleiding",
			"example": "1V2, 2B3, 3H4, ...",
			"description": "De klas van deze leerling."
		},
		"aw_nm_schooljaar": {
			"type": "string",
			"label": "Schooljaar",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description": "Het schooljaar waar de datum van deze les in valt."
		},
		"aw_nms_abs_reden": {
			"type": "array",
			"items": {
				"type": "string"
			},
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"aw_nms_absentiecategorie": {
			"type": "array",
			"items": {
				"type": "string"
			},
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"aw_nms_afspraaktype": {
			"type": "array",
			"items": {
				"type": "string"
			},
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"aw_nr_jaar": {
			"type": "integer",
			"label": "Jaar",
			"category": "Datum",
			"example": "2023, ...",
			"description": "Het viercijferige kalenderjaar van de les."
		},
		"aw_nr_leerjaar": {
			"type": "number",
			"label": "Leerjaar",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description": "Het leerjaar waarin deze leerling geplaatst is."
		},
		"aw_nr_leerling": {
			"type": "number",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"blocklist": {
				"bestuur": true
			}
		},
		"aw_nr_lesuur": {
			"type": "number",
			"label": "Lesuur",
			"category": "Afwezigheid",
			"example": "1 - 8, ...",
			"description": "Het nummer van het tijdslot op de dag waar deze gegevens betrekking op hebben.\nVoor lessen die niet zijn geroosterd op een lesuur is dit veld niet gevuld; in dat geval heeft de les\nalleen een begin- en eindtijd.\nIn het geval van blokuren (lessen van meerdere lesuren) zijn er voor ieder lesuur afzonderlijk gegevens vastgelegd."
		},
		"aw_nr_maand": {
			"type": "integer",
			"minimum": 1,
			"maximum": 12,
			"label": "Maand van het jaar",
			"category": "Datum",
			"example": "1-12",
			"description": "Het maandnummer van het jaar van de les, waarbij januari = 1 en december = 12."
		},
		"aw_nr_minuten": {
			"type": "number",
			"label": "Lestijd (minuten)",
			"category": "Afwezigheid",
			"filter": false,
			"grouping": false,
			"example": "50, 120, ...",
			"description": "Het aantal minuten dat dit lesuur duurde.\nVoor lessen die niet zijn geroosterd op een lesuur is dit veld het aantal minuten dat deze les duurde.\nIn het geval van blokuren (lessen van meerdere lesuren) is de totale lesduur evenredig verdeeld\nover de lesuren; dit kan enigszins afwijken van het lestijdenschema van de school."
		},
		"aw_nr_minuten_aanwezig": {
			"type": "number",
			"label": "Lestijd aanwezig (minuten)",
			"category": "Afwezigheid",
			"filter": false,
			"grouping": false,
			"example": "50, 120, ...",
			"description": "Het aantal minuten dat de leerling dit lesuur aanwezig was.\nDit veld is 0 als de leerling afwezig is geconstateerd.\nAls de leerling aanwezig is geconstateerd, is dit veld gelijk aan aw_nr_minuten met aftrek van eventuele absentiemeldingen (zoals te laat komen of eerder weggaan).\nVoor niet-afgesloten lessen, waarbij geen presentie is geregistreerd, is dit veld leeg."
		},
		"aw_ts_begin": {
			"type": "string",
			"format": "date-time",
			"label": "Begindatum/tijd",
			"category": "Afwezigheid",
			"filter": false,
			"grouping": false,
			"example": "21-04-2023 08:20, ...",
			"description": "De begindatum en -tijd van deze les.\nIn het geval van blokuren (lessen van meerdere lesuren) is bij ieder lesuur de begin- en eindtijd van de gehele les vastgelegd.\nIn exports wordt dit veld standaard weergegeven als dd-mm-jjjj uu:mm, maar in Excel kan de notatie worden aangepast, ook naar enkel een tijd."
		},
		"aw_ts_eind": {
			"type": "string",
			"format": "date-time",
			"label": "Einddatum/tijd",
			"category": "Afwezigheid",
			"filter": false,
			"grouping": false,
			"example": "21-04-2023 09:10, ...",
			"description": "De einddatum en -tijd van deze les.\nIn het geval van blokuren (lessen van meerdere lesuren) is bij ieder lesuur de begin- en eindtijd van de gehele les vastgelegd.\nIn exports wordt dit veld standaard weergegeven als dd-mm-jjjj uu:mm, maar in Excel kan de notatie worden aangepast, ook naar enkel een tijd."
		},
		"aw_t_begin": {
			"type": "string",
			"format": "time",
			"label": "Begintijd",
			"category": "Afwezigheid",
			"filter": false,
			"grouping": false,
			"example": "08:20, 09:10, ...",
			"description": "De begintijd van deze les, als de les geen lesuur heeft."
		},
		"aw_t_eind": {
			"type": "string",
			"format": "time",
			"label": "Eindtijd",
			"category": "Afwezigheid",
			"filter": false,
			"grouping": false,
			"example": "09:05, 10:00, ...",
			"description": "De eindtijd van deze les, als de les geen lesuur heeft."
		}
	}
};
